import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PipeSizeModel } from 'src/app/Modules/informate/models';
import { InputGroup } from 'src/app/Modules/informate/models/calculationModels';
import { IdmApiService } from 'src/app/services';

export class PipeSpecpayload {
    pipeCode: string;
    lookupParams: InputGroup;
}
@Injectable({
    providedIn: 'root',
})
export class JointCalcService {
    pipeSpecList: InputGroup[] = [];
    PipeSpecFilteredList: InputGroup[] = [];
    pipeSpecpayload: PipeSpecpayload;
    isPipeCode: boolean = false;

    isEditPipeSpec: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    ispipeSpec: EventEmitter<boolean> = new EventEmitter<boolean>(null);
    selectedLubricant: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedStandard: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedPressureClass: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedpipeSize: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedflangeType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedflangeFacingType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedflangeMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedgasket: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedBoltType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedboltMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedTighteningSpecification: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedClampManufacturer: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedClampSize: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedclampMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedPipeSchedule: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedhubMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedsealRingMaterial: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedsealRingId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    pipeSizeList: PipeSizeModel[] = [];

    constructor(
        private idmApiService: IdmApiService,
        private jointCalcService: JointCalcService
    ) {}

    async FinddingPipeSpecApicall(payload): Promise<InputGroup[]> {
        const res = await this.idmApiService.findpipespecs(payload).toPromise();
        this.pipeSpecList = res.response.slice();
        this.PipeSpecFilteredList = res.response.slice();
        return this.pipeSpecList;
    }

    async managePayloadForRecourdId(key: string, FilterList, nominal?: number) {
        if (this.PipeSpecFilteredList?.length) {
            if (key != 'pipeSizeId') {
                const selectedLubricantID = this.selectedLubricant?.value;
                const selectedStandardID = this.selectedStandard?.value;
                const selectedPressureClassID = this.selectedPressureClass?.value;
                const selectedFlangeTypeID = this.selectedflangeType?.value;
                const selectedFlangeFacingTypeID = this.selectedflangeFacingType?.value;
                const selectedFlangeMaterialID = this.selectedflangeMaterial?.value;
                const selectedGasketID = this.selectedgasket?.value;
                const selectedBoltTypeID = this.selectedBoltType?.value == 'Metric' ? 0 : this.selectedBoltType?.value == 'Imperial' ? 1 : null;
                const selectedBoltMaterialID = this.selectedboltMaterial?.value;
                const selectedTighteningSpecificationID = this.selectedTighteningSpecification?.value;
                const selectedPipeScheduleID = this.selectedPipeSchedule?.value;
                let pipeSizeList = this?.pipeSizeList;
                const selectedPipeSizeId = this.selectedpipeSize?.value;
                const selectedNominalPipeSize = pipeSizeList?.find((pipeSize) => pipeSize.pipeSizeId == selectedPipeSizeId)?.nominalPipeSize;

                if (key === 'flangeMaterialId' || key === 'boltMaterialId' || key === 'gasketId') {
                    const selectedPressureClassID = this.selectedPressureClass?.value;
                    //let pipeSpecList;
                    if (selectedPressureClassID) {
                        if (key == 'flangeMaterialId') {
                            this.pipeSpecList = this.PipeSpecFilteredList.filter(
                                (x) =>
                                    x.recordId.lubricantId == selectedLubricantID &&
                                    x.recordId.standardId == selectedStandardID &&
                                    x.recordId.pressureClassId == selectedPressureClassID &&
                                    x.recordId.flangeTypeId == selectedFlangeTypeID &&
                                    selectedNominalPipeSize >= x.minimumNominalPipeSize &&
                                    selectedNominalPipeSize <= x.maximumNominalPipeSize &&
                                    x.recordId.flangeFacingTypeId == selectedFlangeFacingTypeID
                            );
                        } else if (key == 'gasketId') {
                            this.pipeSpecList = this.PipeSpecFilteredList.filter(
                                (x) =>
                                    x.recordId.lubricantId == selectedLubricantID &&
                                    x.recordId.standardId == selectedStandardID &&
                                    x.recordId.pressureClassId == selectedPressureClassID &&
                                    x.recordId.flangeTypeId == selectedFlangeTypeID &&
                                    selectedNominalPipeSize >= x.minimumNominalPipeSize &&
                                    selectedNominalPipeSize <= x.maximumNominalPipeSize &&
                                    x.recordId.flangeFacingTypeId == selectedFlangeFacingTypeID &&
                                    x.recordId.flangeMaterialId == selectedFlangeMaterialID
                            );
                        } else if (key == 'boltMaterialId') {
                            this.pipeSpecList = this.PipeSpecFilteredList.filter(
                                (x) =>
                                    x.recordId.lubricantId == selectedLubricantID &&
                                    x.recordId.standardId == selectedStandardID &&
                                    x.recordId.pressureClassId == selectedPressureClassID &&
                                    x.recordId.flangeTypeId == selectedFlangeTypeID &&
                                    selectedNominalPipeSize >= x.minimumNominalPipeSize &&
                                    selectedNominalPipeSize <= x.maximumNominalPipeSize &&
                                    x.recordId.flangeFacingTypeId == selectedFlangeFacingTypeID &&
                                    x.recordId.flangeMaterialId == selectedFlangeMaterialID &&
                                    x.recordId.gasketId == selectedGasketID &&
                                    x.others.boltType == selectedBoltTypeID
                            );
                        }
                    } else if (this.selectedClampManufacturer?.value) {
                        this.pipeSpecList = this.PipeSpecFilteredList.filter((x) => x.recordId.manufacturerId == this.selectedClampManufacturer?.value);
                    }

                    let standardpipeSpec = this.pipeSpecList
                        .map((x) => {
                            if (x && x.recordId && x.recordId[key]) {
                                return {
                                    Id: x.recordId[key],
                                    AliasId:
                                        key === 'flangeMaterialId'
                                            ? x.recordId['flangeMaterialAliasId']
                                            : key === 'boltMaterialId'
                                              ? x.recordId['boltMaterialAliasId']
                                              : key === 'gasketId'
                                                ? x.recordId['gasketAliasId']
                                                : '',
                                };
                            }
                        })
                        .filter((x) => x !== undefined);

                    if (standardpipeSpec?.length) {
                        // Check if any aliasId exists
                        const hasAlias = standardpipeSpec.some((x) => x.AliasId);

                        if (hasAlias) {
                            // Deduplicate based on aliasId
                            const uniqueAliases = [...new Set(standardpipeSpec.filter((x) => x.AliasId).map((x) => x.AliasId))];

                            // Filter only on aliasId
                            FilterList = FilterList.filter((item) => uniqueAliases.includes(item?.alias?.materialAliasId));

                            const uniqueIds = [...new Set(standardpipeSpec.map((x) => x.Id))];
                            // Filter only on flangeMaterialId/boltMaterialAliasId/gasketAliasId
                            FilterList = FilterList.filter((item) => uniqueIds.includes(item[key]));
                        } else {
                            // Deduplicate based on flangeMaterialId/boltMaterialAliasId/gasketAliasId
                            const uniqueIds = [...new Set(standardpipeSpec.map((x) => x.Id))];

                            // Filter only on flangeMaterialId/boltMaterialAliasId/gasketAliasId
                            FilterList = FilterList.filter((item) => uniqueIds.includes(item[key]));
                        }
                    } else {
                        FilterList = [...FilterList];
                    }
                } else {
                    if (key == 'flangeTypeId') {
                        this.pipeSpecList = this.PipeSpecFilteredList.filter(
                            (x) =>
                                x.recordId.lubricantId == selectedLubricantID &&
                                x.recordId.standardId == selectedStandardID &&
                                x.recordId.pressureClassId == selectedPressureClassID &&
                                selectedNominalPipeSize >= x.minimumNominalPipeSize &&
                                selectedNominalPipeSize <= x.maximumNominalPipeSize
                        );
                    } else if (key == 'flangeFacingTypeId') {
                        this.pipeSpecList = this.PipeSpecFilteredList.filter(
                            (x) =>
                                x.recordId.lubricantId == selectedLubricantID &&
                                x.recordId.standardId == selectedStandardID &&
                                x.recordId.pressureClassId == selectedPressureClassID &&
                                selectedNominalPipeSize >= x.minimumNominalPipeSize &&
                                selectedNominalPipeSize <= x.maximumNominalPipeSize &&
                                x.recordId.flangeTypeId == selectedFlangeTypeID
                        );
                    } else if (key == 'pipeScheduleId') {
                        if (this.selectedClampManufacturer?.value) {
                            this.pipeSpecList = this.PipeSpecFilteredList.filter(
                                (x) =>
                                    x.recordId.manufacturerId == this.selectedClampManufacturer?.value &&
                                    x.recordId.boltMaterialId == selectedBoltMaterialID &&
                                    x.recordId.clampMaterialId == this.selectedclampMaterial?.value
                            );
                        } else {
                            this.pipeSpecList = this.PipeSpecFilteredList.filter(
                                (x) =>
                                    x.recordId.lubricantId == selectedLubricantID &&
                                    x.recordId.standardId == selectedStandardID &&
                                    x.recordId.pressureClassId == selectedPressureClassID &&
                                    x.recordId.flangeTypeId == selectedFlangeTypeID &&
                                    selectedNominalPipeSize >= x.minimumNominalPipeSize &&
                                    selectedNominalPipeSize <= x.maximumNominalPipeSize &&
                                    x.recordId.flangeFacingTypeId == selectedFlangeFacingTypeID &&
                                    x.recordId.flangeMaterialId == selectedFlangeMaterialID &&
                                    x.recordId.gasketId == selectedGasketID &&
                                    x.others.boltType == selectedBoltTypeID &&
                                    x.recordId.boltMaterialId == selectedBoltMaterialID &&
                                    x.others.tighteningSpecification == selectedTighteningSpecificationID
                            );
                        }
                    } else if (key == 'clampMaterialId') {
                        this.pipeSpecList = this.PipeSpecFilteredList.filter(
                            (x) =>
                                x.recordId.manufacturerId == this.selectedClampManufacturer?.value &&
                                x.recordId.boltMaterialId == selectedBoltMaterialID &&
                                selectedNominalPipeSize >= x.minimumNominalPipeSize &&
                                selectedNominalPipeSize <= x.maximumNominalPipeSize
                        );
                    } else if (key == 'hubMaterialId') {
                        this.pipeSpecList = this.PipeSpecFilteredList.filter(
                            (x) =>
                                x.recordId.manufacturerId == this.selectedClampManufacturer?.value &&
                                x.recordId.boltMaterialId == selectedBoltMaterialID &&
                                x.recordId.clampMaterialId == this.selectedclampMaterial?.value &&
                                x.recordId.pipeScheduleId == selectedPipeScheduleID
                        );
                    } else if (key == 'sealRingMaterialId') {
                        this.pipeSpecList = this.PipeSpecFilteredList.filter(
                            (x) =>
                                x.recordId.manufacturerId == this.selectedClampManufacturer?.value &&
                                x.recordId.boltMaterialId == selectedBoltMaterialID &&
                                x.recordId.clampMaterialId == this.selectedclampMaterial?.value &&
                                x.recordId.pipeScheduleId == selectedPipeScheduleID &&
                                x.recordId.hubMaterialId == this.selectedhubMaterial?.value
                        );
                    } else {
                        if (selectedPressureClassID) {
                            this.pipeSpecList = this.PipeSpecFilteredList.filter((x) => x.recordId.pressureClassId == selectedPressureClassID);
                        } else if (this.selectedClampManufacturer?.value) {
                            this.pipeSpecList = this.PipeSpecFilteredList.filter((x) => x.recordId.manufacturerId == this.selectedClampManufacturer?.value);
                        }
                    }
                    let standardpipeSpec = this.pipeSpecList.map((x) => {
                        if (x && x.recordId && x.recordId[key]) {
                            return x.recordId[key];
                        }
                    });
                    if (standardpipeSpec?.length && (standardpipeSpec[0] != undefined || standardpipeSpec[0] != null)) {
                        standardpipeSpec = [...new Set(standardpipeSpec)];
                        FilterList = FilterList.filter((item) => standardpipeSpec.includes(item[key]));
                    } else {
                        // file deepcode ignore CopyPasteError: <please specify a reason of ignoring this>, file deepcode ignore JavascriptSelfAssignment: <please specify a reason of ignoring this>
                        FilterList = [...FilterList];
                    }
                }
                return FilterList;
            } else {
                return this.PipeSpecFilteredList;
            }
        }
    }

    async managePayloadForOthers(key: string, FilterList) {
        if (this.pipeSpecList?.length) {
            if (key != 'pipeSizeId') {
                let standardpipeSpec = this.pipeSpecList.map((x) => {
                    if (x && x.others && x.others[key]) {
                        return x.others[key];
                    }
                });
                if (standardpipeSpec?.length && (standardpipeSpec[0] != undefined || standardpipeSpec[0] != null)) {
                    standardpipeSpec = [...new Set(standardpipeSpec)];
                    FilterList = FilterList.filter((item) => standardpipeSpec.includes(item['key']));
                } else {
                    // file deepcode ignore CopyPasteError: <please specify a reason of ignoring this>, file deepcode ignore JavascriptSelfAssignment: <please specify a reason of ignoring this>
                    FilterList = [...FilterList];
                }

                return FilterList;
            } else {
                return this.PipeSpecFilteredList;
            }
        }
    }

    filterList(payload: InputGroup): any[] {
        const filters = [
            'lubricantId',
            'standardId',
            'pressureClassId',
            'flangeTypeId',
            'flangeFacingTypeId',
            'flangeMaterialId',
            'gasketId',
            'boltMaterialId',
            'manufacturerId',
            'clampMaterialId',
            'pipeScheduleId',
            'hubMaterialId',
            'sealRingMaterialId',
        ];

        const otherFilters = ['boltType', 'tighteningSpecification'];

        const list = this.PipeSpecFilteredList.filter((item) => {
            return (
                filters.every((key) => !payload?.recordId?.[key] || item.recordId[key] === payload.recordId[key]) &&
                otherFilters.every((key) => !payload?.others?.[key] || item.others[key] === payload.others[key]) &&
                (!payload.nominal || (payload.nominal >= item.minimumNominalPipeSize && payload.nominal <= item.maximumNominalPipeSize))
            );
        });
        console.log('filtered list', list);
        return list;
    }
}
